import React, {Fragment, useEffect, useState} from "react" ;

const TeamSidebarGroup = (props) =>
{
    const [selected, setSelected] = useState(props.default);

    useEffect(() => {
        setSelected(props.default);
    }, [props.default]);

    const isActive = (myTag, index) =>
    {
        if ( selected === 'first' && index === 0 )
        {
            return true ;
        }
        else
        {
            return myTag === selected;
        }
    }

    const onMenuItemClick = (item) =>
    {
        setSelected(item);
    }

    const renderChildren = () =>
    {
        if (React.Children !== undefined)
        {
            return React.Children.map(props.children, (child,index) =>
            {
                if (React.isValidElement(child))
                {
                    return React.cloneElement(child, {onClick: onMenuItemClick, active: isActive(child.props.name, index)});
                }
            })
        }
    }

    return (
        <Fragment key='section'>
            <li className="dt-side-nav__item dt-side-nav__header" key='li1'>
                <span className="dt-side-nav__text">{props.title}</span>
            </li>
            {renderChildren()}
        </Fragment>
    )
}

export default TeamSidebarGroup;
